const getEventLocation = (event) => {
  const { gameStoreName, city, state, country } = event;

  if (!gameStoreName) return "";
  return [gameStoreName, city, state, country]
    .filter((parameter) => parameter)
    .join(", ");
};

const getEventStatus = (started, ended) => {
  return ended ? "Ended" : started ? "Started" : "Not Started";
};
// const getEventStatus = (started, ended, currentRound) => {
//   return ended
//     ? "Ended"
//     : started && currentRound > 0
//     ? "Started"
//     : "Not Started";
// };

const getEventGameSystem = (event, gameSystemDict) => {
  if (event.gameSystemId && gameSystemDict[event.gameSystemId]) {
    event.gameSystem = gameSystemDict[event.gameSystemId];
  }
  return event.gameSystem;
};

export const mapData = (data = [], gameSystemDict, moment) => {
  return data
    .sort((a, b) => {
      return moment(b.eventEndDate).diff(moment(a.eventEndDate));
    })
    .map((event) => ({
      ...event,
      gameSystem: getEventGameSystem(event, gameSystemDict),
      // status: getEventStatus(event.started, event.ended, event.currentRound),
      status: getEventStatus(event.started, event.ended),
      eventLocation: getEventLocation(event),
    }));
};

export const newEventParallelData = async (
  userId,
  fetchGameStores,
  getGameSystems,
  fetchUser,
  fetchLocations
) => {
  const apiGameStores = fetchGameStores();
  const apiGameSystems = getGameSystems();
  const apiUser = fetchUser(userId);
  const apiLocations = fetchLocations();

  return {
    apiGameStores: await apiGameStores,
    apiGameSystems: await apiGameSystems,
    apiUser: userId ? await apiUser : {},
    apiLocations: await apiLocations,
  };
};

export const urlToString = (string) => {
  return decodeURIComponent(string);
};

export const stringToUrl = (string) => {
  return encodeURIComponent(string);
};
